module.exports = __webpack_public_path__ + "static/media/dolly-empty.a5f75600.svg";